import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=359acf26&scoped=true"
var script = {}
import style0 from "./Review.vue?vue&type=style&index=0&id=359acf26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359acf26",
  null
  
)

export default component.exports